import axios from "axios";

const axiosInstance = axios.create({
  baseURL: (import.meta as any).env.VITE_BASE_URL,
  headers: {
    "ngrok-skip-browser-warning": "abc",
  },
});

export default axiosInstance;
